import { CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useModules from "src/hooks/useModules";

const ModuleAndChapterListing = () => { 
   
  const { modules, isDataLoading} = useModules()
  

  const navigate = useNavigate(); 

  useEffect(()=>{
    if(!isDataLoading){
      navigate(`/configuration/modules-chapter/${modules?.[0]?._id}`)
    }
 // eslint-disable-next-line react-hooks/exhaustive-deps
 },[isDataLoading,modules]) 
  return(
   
      <div className="flex justify-center items-center h-[300px]">
         <CircularProgress/>
      </div>
   
  
  )
};

export default ModuleAndChapterListing;
